import React from 'react';
import HeaderColumnCell from './HeaderColumnCell';
import ColumnText from './ColumnText';

const DefaultHeaderColumn = props => {
    const { labelText, titleText, ...restProps } = props;
    return (
        <HeaderColumnCell {...restProps}>
            <ColumnText labelText={labelText} titleText={titleText} />
        </HeaderColumnCell>
    );
};

export default DefaultHeaderColumn;
